<template>
  <van-field
    :label="label"
    :rules="rules"
    :value="text"
    :input-align="inputAlign"
    readonly
    clickable
    @click="visible=true"
  >
    <template #input>
      {{ text || placeholder }}
      <van-popup v-model="visible" position="bottom" get-container="body">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="visible = false"
        />
      </van-popup>
    </template>
    <template #extra>
      <van-icon name="arrow-down" />
    </template>
  </van-field>
</template>

<script>
export default {
  name: 'WhFieldSelectPopup',
  model: {
    prop: 'selectValue',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: '选择'
    },
    selectValue: {
      type: [String, Number, Object],
      default: ''
    },
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    rules: {
      type: Array,
      default: undefined
    },
    inputAlign: {
      type: String,
      default: 'right'
    },
    valueKey: {
      type: String,
      default() {
        return undefined
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    text() {
      const val = (this.columns.find(i => {
        if (i.constructor === String || i.constructor === Number) {
          return i === this.selectValue
        }
        if (i.constructor === Object) {
          if (i.value.constructor === Object) {
            return i.value[this.valueKey] === this.selectValue[this.valueKey]
          } else if (i.value.constructor === Number || i.value.constructor === String) {
            return i.value === this.selectValue
          }
        }
      }))
      if (!val) return ''
      if (val.constructor === Object) {
        return val.text
      } else {
        return val
      }
    }
  },
  methods: {
    onConfirm(val, index) {
      if (val.constructor === Object) {
        this.$emit('change', val.value)
      } else {
        this.$emit('change', val)
      }
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.van-icon-arrow-down {
  margin: 5px;
}
</style>
